/* DS Advertorial — shared scroll-reveal for .ds-anim elements.
   Self-contained, runs once, safe if loaded multiple times. */
(function () {
  if (window.__dsAnimInit) return;
  window.__dsAnimInit = true;

  function reveal() {
    var nodes = document.querySelectorAll('.ds-anim:not(.ds-in)');
    if (!nodes.length) return;
    if (
      !('IntersectionObserver' in window) ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      nodes.forEach(function (n) { n.classList.add('ds-in'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('ds-in');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -30px 0px' }
    );
    nodes.forEach(function (n) { io.observe(n); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reveal);
  } else {
    reveal();
  }
  // Re-scan when sections are added/edited in the theme editor.
  document.addEventListener('shopify:section:load', reveal);
})();
